import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faAngellist } from '@fortawesome/free-brands-svg-icons/faAngellist';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/codzz',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.facebook.com/ajithjozef',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.instagram.com/joseph__ajith/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.linkedin.com/in/ajithjozef',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://angel.co/u/ajith-joseph-4',
    label: 'Angel List',
    icon: faAngellist,
  },
  {
    link: 'https://twitter.com/ajithjosef',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'mailto:contact@ajithjoseph.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
